module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "brown lighten-2",
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Aliments favoris")])], 1), _vm._v(" "), _c('v-list', [_vm._l((_vm.favorites), function(favorite, index) {
    return [_c('v-list-tile', {
      key: favorite.id,
      attrs: {
        "avatar": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.addFavorite(favorite)
        }
      }
    }, [_c('v-list-tile-avatar', [(favorite.portion_pict) ? _c('v-btn', {
      attrs: {
        "icon": "",
        "large": "",
        "ripple": ""
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.pictPath(favorite.portion_pict)
      }
    })]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(favorite.food_name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.favoritePortionDescription(favorite)))])], 1)], 1), _vm._v(" "), (index + 1 < _vm.favorites.length) ? _c('v-divider', {
      key: favorite.id + '-'
    }) : _vm._e()]
  })], 2), _vm._v(" "), (_vm.favorites.length === 0) ? _c('v-card-text', {
    staticClass: "Aligner",
    staticStyle: {
      "height": "80px"
    }
  }, [_c('v-icon', [_vm._v("not_interested")])], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b8eddb5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nutrieduc/Favorites.vue
// module id = 1213
// module chunks = 1